module.exports = __webpack_public_path__ + "static/media/multifinance.9ed029fa.png";